import React from 'react';

export default function TagsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.25235 0.799805L4.76953 14.7998" stroke="currentColor" strokeLinecap="round" />
      <path d="M11.643 0.799805L9.16016 14.7998" stroke="currentColor" strokeLinecap="round" />
      <path d="M2.04199 5.8621H14.9999" stroke="currentColor" strokeLinecap="round" />
      <path d="M1 10.4646H13.9579" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}
